module.exports = __webpack_public_path__ + "elephant_ui_plane-e3f2d57c12c376e189c274cbe81af8dd.svg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/elephant_ui_plane.svg
// module id = 164
// module chunks = 86